import { render, staticRenderFns } from "./MyApprovals.vue?vue&type=template&id=10f32694"
import script from "./MyApprovals.vue?vue&type=script&lang=js"
export * from "./MyApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports